

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterModule} from "@angular/router";
import {MatTreeModule} from "@angular/material/tree";
import {TranslateModule} from "@ngx-translate/core";
import {SupplierComponent} from "./supplier.component";
import {SupplierFormComponent} from "./supplierForm.component";
import {SupplierDialogComponent} from "./dialog/supplierDialog.component";
import {SupplierMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {SupplierOrderModule} from "../supplierOrder/supplierOrder.module";

@NgModule({
    declarations: [
        SupplierComponent,
        SupplierFormComponent,
        SupplierDialogComponent,
        SupplierMainSidebarComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        MatTreeModule,
        TranslateModule,
        SupplierOrderModule,
    ],
    providers: [],
    bootstrap: [
        SupplierComponent,
        SupplierFormComponent,
        SupplierDialogComponent,
        SupplierMainSidebarComponent,
    ]
})
export class SupplierModule { }
